
import { Loader2 } from 'lucide-react';

interface TemplatePreviewProps {
    htmlContent: string;
    isLoading: boolean;
}

export function TemplatePreview({ htmlContent, isLoading }: TemplatePreviewProps) {
    return (
        <div className="aspect-video w-full bg-gray-100 rounded-md overflow-hidden border relative">
            {isLoading && (
                <div className="absolute inset-0 bg-gray-100/80 flex flex-col items-center justify-center z-10">
                    <Loader2 className="h-8 w-8 animate-spin text-gray-500 mb-2" />
                    <p className="text-gray-500 text-sm">جاري تحميل المعاينة...</p>
                </div>
            )}
            <iframe
                srcDoc={htmlContent}
                title="Template Preview"
                className="w-full h-full border-0 absolute top-0 left-0"
                style={{
                    transform: 'scale(0.55)',
                    transformOrigin: 'top left',
                    width: '181.81%',
                    height: '181.81%',
                }}
                sandbox="allow-same-origin"
            />
        </div>
    );
}
